import { useState, Fragment } from "react"
import { useRouter } from "next/navigation"
import { CheckIcon, XMarkIcon } from "@heroicons/react/24/outline"

export default function CompetitionSignUp({ options, setPopup }) {

    const router = useRouter()
    const [ categorySelected, setCategorySelected ] = useState(null)

    return (
        <div className="popup">
            <div className="popup-content flex flex-col gap-6 !w-fit !h-fit">
                <button
                    className="btn btn-close"
                    onClick={() => {
                        setPopup(null)
                        setCategorySelected(null)
                    }}
                    aria-label="關閉報名組別選擇視窗"
                ><XMarkIcon /></button>
                <div className="flex flex-col gap-2 sm:w-[400px]">
                    <div className="text-black-900 font-semibold text-2xl mb-2">選擇報名組別</div>
                    <div className="text-black-700 text font-light">
                        同一作品，只能投遞單一組別。
                    </div>
                    <div className="text-black-700 text-sm font-light">
                        除非內容呈現型態不同，例如動畫作品衍伸的海報設計物，可另外投遞設計類視覺設計組，但需要另外準備該類組要求的繳交資料，分別投件報名！
                    </div>
                </div>
                <div className="sm:w-[400px] h-[55vh] py-4 overflow-x-hidden overflow-y-auto rounded-lg border border-black-300 shadow">
                    { options?.map(data => (
                        <Fragment key={data.shortcut}>
                            <p className="px-5 my-2 text-xs text-black-700 font-normal">{data.name}</p>
                            { data.subcategory.map(sub => (
                                <div
                                    key={sub.shortcut}
                                    className={`flex items-center py-2 px-5 text-base transition cursor-pointer font-light${(categorySelected && (categorySelected.categ && categorySelected.categ === data.shortcut) && (categorySelected.subCateg && categorySelected.subCateg === sub.shortcut)) ? " bg-main text-white" : " text-black-900 hover:bg-main-300"}`}
                                    onClick={() => {
                                        setCategorySelected({
                                            categ: data.shortcut,
                                            subCateg: sub.shortcut
                                        })
                                    }}
                                >
                                    <CheckIcon className="w-5 stroke-black-100" />
                                    <span className="ml-3">{sub.name}</span>
                                </div>
                            ))}
                        </Fragment>
                    ))}
                </div>
                <button
                    className="btn btn-black btn-round w-full"
                    type="submit"
                    disabled={categorySelected === null}
                    onClick={() => {
                        router.push(`/user/compete/registration/${categorySelected.categ}/${categorySelected.subCateg}`)
                    }}
                >開始報名</button>
            </div>
        </div>
    )
}